import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-assign-audits',
    templateUrl: './assign-audits.component.html',
    styleUrl: './assign-audits.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssignAuditsComponent {

}
